import React from 'react';
import { BookOpen, Sparkles, Download, Infinity as InfinityIcon, Award, CheckCircle } from 'lucide-react';
import { SectionReveal, SectionHeading } from './Shared';
export const Curriculum = () => {
  const modules = [{
    num: 1,
    title: 'Fundamentos de los Registros Akáshicos'
  }, {
    num: 2,
    title: 'Preparación Energética y Apertura del Canal'
  }, {
    num: 3,
    title: 'Apertura de los Registros Akáshicos'
  }, {
    num: 4,
    title: 'Interpretación de Mensajes y Lecturas Akáshicas'
  }, {
    num: 5,
    title: 'Lecturas para Uno Mismo y para Otras Personas'
  }, {
    num: 6,
    title: 'Maestría y Desarrollo Profesional Akáshico'
  }];
  const bonuses = [{
    title: 'Manual de Preguntas Poderosas',
    desc: 'Más de 200 preguntas para profundizar lecturas.',
    cover: 'https://cdn.magicpatterns.com/uploads/nWCftzGBAZBUWSWzLBFWuv/PORTADA_BONO_1.png'
  }, {
    title: 'Guía Profesional de Primeras Sesiones',
    desc: 'Paso a paso para realizar lecturas con seguridad.',
    cover: 'https://cdn.magicpatterns.com/uploads/j9yw17kqhCJSCiaSiJu8DK/PORTADA_BONO_2.png'
  }, {
    title: 'Protocolos Avanzados de Lectura y Acompañamiento',
    desc: 'Modelos profesionales para consultas complejas.',
    cover: 'https://cdn.magicpatterns.com/uploads/3jSe6uidAzByu3JSVdPakH/PORTADA_BONO_3.png'
  }, {
    title: 'El Lector Consciente',
    desc: 'Autocuidado, ética y desarrollo profesional.',
    cover: 'https://cdn.magicpatterns.com/uploads/eQh8wf9mQk9SzDTeot76Uf/PORTADA_BONO_4.png'
  }];
  const methodology = [{
    text: '100% digital.',
    icon: <BookOpen className="w-5 h-5" data-id="element-39" />
  }, {
    text: 'Acceso inmediato.',
    icon: <Sparkles className="w-5 h-5" data-id="element-40" />
  }, {
    text: 'Material organizado por módulos.',
    icon: <CheckCircle className="w-5 h-5" data-id="element-41" />
  }, {
    text: 'Formación autodidacta.',
    icon: <BookOpen className="w-5 h-5" data-id="element-42" />
  }, {
    text: 'Recursos prácticos incluidos.',
    icon: <CheckCircle className="w-5 h-5" data-id="element-43" />
  }, {
    text: 'Descarga ilimitada.',
    icon: <Download className="w-5 h-5" data-id="element-44" />
  }, {
    text: 'Acceso de por vida.',
    icon: <InfinityIcon className="w-5 h-5" data-id="element-45" />
  }, {
    text: 'Certificado digital.',
    icon: <Award className="w-5 h-5" data-id="element-46" />
  }];
  return <>
      {/* SECCIÓN 5: CONTENIDO DE LA FORMACIÓN */}
      <SectionReveal data-id="element-47">
        <div className="container mx-auto px-6 max-w-6xl" data-id="element-48">
          <div className="text-center mb-16" data-id="element-49">
            <div className="text-gold mb-4 font-medium tracking-widest uppercase text-sm" data-id="element-50">
              Contenido de la formación
            </div>
            <h2 className="text-3xl md:text-5xl font-serif text-gold-light mb-6" data-id="element-51">
              Incluye 6 Módulos Profesionales
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-52" />
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-53">
            {modules.map(mod => <div key={mod.num} className="bg-celestial-800/40 border border-gold/10 rounded-2xl p-8 relative overflow-hidden group hover:border-gold/40 transition-colors" data-id="element-54">
                <div className="absolute -right-4 -top-4 text-9xl font-serif text-gold/5 font-bold group-hover:text-gold/10 transition-colors pointer-events-none" data-id="element-55">
                  {mod.num}
                </div>
                <div className="text-gold font-medium mb-3 uppercase tracking-wider text-sm" data-id="element-56">
                  Módulo {mod.num}
                </div>
                <h3 className="text-xl font-serif text-gold-light relative z-10 leading-snug" data-id="element-57">
                  {mod.title}
                </h3>
              </div>)}
          </div>
        </div>
      </SectionReveal>

      {/* SECCIÓN 6: BONOS PREMIUM */}
      <SectionReveal className="bg-gradient-to-b from-transparent via-celestial-800/50 to-transparent relative" data-id="element-58">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1534796636912-3b95b3ab5986?q=80&w=2342&auto=format&fit=crop')] opacity-[0.03] mix-blend-screen pointer-events-none" data-id="element-59"></div>

        <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-60">
          <div className="text-center mb-16" data-id="element-61">
            <div className="inline-flex items-center justify-center space-x-2 bg-gold/10 border border-gold/30 px-4 py-1.5 rounded-full mb-6" data-id="element-62">
              <Sparkles className="w-4 h-4 text-gold" data-id="element-63" />
              <span className="text-gold-light text-sm font-medium tracking-wider uppercase" data-id="element-64">
                Bonos Premium
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-serif text-gold-light mb-6" data-id="element-65">
              Además recibís 4 Bonos Exclusivos
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-66">
            {bonuses.map((bono, idx) => <div key={idx} className="flex items-center gap-5 bg-celestial-900/80 backdrop-blur-md border border-gold/20 rounded-2xl p-5 hover:shadow-[0_0_30px_rgba(212,175,55,0.15)] hover:border-gold/40 transition-all" data-id="element-67">
                <div className="relative w-24 sm:w-28 flex-shrink-0" data-id="element-68">
                  <div className="absolute -inset-1 bg-gold/20 blur-md rounded-lg pointer-events-none" data-id="element-69"></div>
                  <img src={bono.cover} alt={`Portada del bono premium: ${bono.title}`} className="relative w-full h-auto rounded-lg border border-gold/30 shadow-[0_8px_20px_rgba(0,0,0,0.5)]" data-id="element-70" />
                </div>
                <div data-id="element-71">
                  <span className="inline-block text-xs font-medium uppercase tracking-wider text-gold bg-gold/10 border border-gold/20 px-2.5 py-0.5 rounded-full mb-2" data-id="element-72">
                    Bono Premium {idx + 1}
                  </span>
                  <h4 className="text-lg font-serif text-gold-light mb-1.5 leading-snug" data-id="element-73">
                    {bono.title}
                  </h4>
                  <p className="text-indigo-100/70 text-sm" data-id="element-74">{bono.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </SectionReveal>

      {/* SECCIÓN 7: METODOLOGÍA */}
      <SectionReveal data-id="element-75">
        <div className="container mx-auto px-6 max-w-4xl" data-id="element-76">
          <SectionHeading title="Una Formación Diseñada Para Aprender de Forma Clara" subtitle="Metodología de estudio" data-id="element-77" />

          <div className="bg-celestial-800/30 border border-gold/10 rounded-3xl p-8 md:p-12" data-id="element-78">
            <div className="grid sm:grid-cols-2 gap-y-6 gap-x-12" data-id="element-79">
              {methodology.map((item, idx) => <div key={idx} className="flex items-center space-x-4" data-id="element-80">
                  <div className="text-gold bg-gold/10 p-2 rounded-lg" data-id="element-81">
                    {item.icon}
                  </div>
                  <span className="text-indigo-100/90 font-medium" data-id="element-82">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </SectionReveal>
    </>;
};